module.exports = __webpack_public_path__ + "static/media/Maven_4420.48ab7090.jpg";